import { Slider } from "@mui/material";
import { useState } from "react";

interface NegativePositiveSliderProps {
  defaultValue: number | null;
  onInputChange?: (...values: unknown[]) => void;
  disabled?: boolean;
}

const marks = [
  {
    value: -3,
    label: "-3",
  },
  {
    value: -2,
    label: "-2",
  },
  {
    value: -1,
    label: "-1",
  },
  {
    value: 0,
    label: "0",
  },
  {
    value: 1,
    label: "1",
  },
  {
    value: 2,
    label: "2",
  },
  {
    value: 3,
    label: "3",
  },
];

function NegativePositiveSlider({
  defaultValue,
  onInputChange,
  disabled,
}: NegativePositiveSliderProps){
  const [inputValue, setInputValue] = useState(defaultValue ?? 0);

  const onChange = (
    _: Event,
    newValue: number | number[],
    __: number
  ): void => {
    setInputValue(Array.isArray(newValue) ? newValue[0] : newValue);
    if (onInputChange) {
      onInputChange(newValue);
    }
  };

  return (
    <div className="flex w-full flex-col items-center px-2 pt-4">
      <Slider
        className="w-full"
        classes={{
          track: "bg-rmh-deepblue-500",
          rail: "bg-rmh-deepblue-25",
        }}
        disabled={disabled}
        marks={marks}
        max={3}
        min={-3}
        onChange={onChange}
        step={1}
        value={typeof inputValue === "number" ? inputValue : 0}
        valueLabelDisplay="off"
      />
    </div>
  );
}

export default NegativePositiveSlider;
